import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import { colors } from "../colors";
import LoginModal from "../components/Modals/LoginModal";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loginModalOpen, setLoginModalOpen] = useState(true);
  const userType = searchParams.get('type') || 'staff'; // Default to staff if no type specified

  useEffect(() => {
    // Ensure modal is open when component mounts
    setLoginModalOpen(true);
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        background: `linear-gradient(135deg, ${colors.primaryLight} 50%, white 70%)`,
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <LoginModal 
        open={loginModalOpen} 
        onClose={() => {
          setLoginModalOpen(false);
          // Navigate back to landing page when modal closes
          navigate("/");
        }}
        showRegister={userType === 'student'}
        isStudent={userType === 'student'}
      />
    </Box>
  );
};

export default Login;
